var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('Spinner',{staticClass:"loading",attrs:{"size":55,"line-size":7,"line-fg-color":"#C5C5C5","speed":0.6}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }